import { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import RHFLexicalEditor, {
  preloadLexicalEditor,
} from '@/components/HookForm/RHFLexicalEditor';
import EditorSkeleton from '@/components/HookForm/RHFLexicalEditor/EditorSkeleton';
import { ContentFieldBlock, FieldHeader } from './styles';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';

type ContentFieldProps = {
  /**
   * Lexical 에디터는 mount 후 value 변경에 응답하지 않으므로,
   * 양식 응답이 폼에 적용된 뒤에만 mount. 편집 모드는 항상 true.
   */
  ready: boolean;
  /** 유형별 에디터 플러그인(계약 품의 AI 초안 섹션 등) */
  plugins?: ReactNode;
};

const ContentField = ({ ready, plugins }: ContentFieldProps) => {
  const { t } = useTranslation();

  // 양식 응답을 기다리는 동안 에디터 코드를 미리 받아, 두 대기가 차례로 이어지지 않게 함
  useEffect(() => {
    preloadLexicalEditor();
  }, []);

  return (
    <ContentFieldBlock>
      <FieldHeader>
        <InfoSectionTitle>{t('내용')}</InfoSectionTitle>
      </FieldHeader>
      {ready ? (
        <RHFLexicalEditor
          name="content"
          defaultFontSize={16}
          plugins={plugins}
        />
      ) : (
        <EditorSkeleton />
      )}
    </ContentFieldBlock>
  );
};

export default ContentField;
